import * as React from 'react';
import { Api } from '../../../../typings/api';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import { setFormFieldsByContact, contactKeyByFieldName } from '../../../../containers/Share/actions';
import Menu from '../../../DropdownMenu';
import { MenuConfig } from '../../../DropdownMenu';
import { filterWithMax } from '../../../../utils/optimization';

interface CrmAutocompleteChoicesProps {
	fieldName: string;
	fieldValue: string;
	hasFocus: boolean;
	crmContacts: Api.CrmContact[];
	dispatch: Dispatch<StoreState>;
}

const CrmAutocompleteChoices = ({
	fieldName,
	fieldValue,
	hasFocus,
	crmContacts,
	dispatch,
}: CrmAutocompleteChoicesProps) => {

	const [isOpen, setIsOpen] = React.useState(false);
	const [filteredContacts, setFilteredContacts] = React.useState([] as Api.CrmContact[]);
	const [filterChoicesTimeout, setFilterChoicesTimeout] = React.useState(null as NodeJS.Timer | null);

	const minimumFieldCharacters = 3;

	React.useEffect( () => {
		const shouldOpen = hasFocus && minimumFieldCharacters <= fieldValue.length;
		setIsOpen(shouldOpen);
	}, [fieldValue, hasFocus]);

	React.useEffect( () => {
		if (filterChoicesTimeout) {
			clearTimeout(filterChoicesTimeout);
		}

		const maximumSuggestions = 15;
		const filterChoices = (contact: Api.CrmContact, fieldName: string, fieldValue: string): boolean => {
			const contactField: string | null = contact[contactKeyByFieldName[fieldName]];
			return !!(contactField && contactField.toLowerCase().includes(fieldValue.toLowerCase()));
		};

		setFilterChoicesTimeout(global.setTimeout(() => {
			if (minimumFieldCharacters <= fieldValue.length) {
				const filteredContacts = Array.from(
					filterWithMax(
						crmContacts,
						(contact: Api.CrmContact) => filterChoices(contact, fieldName, fieldValue),
						maximumSuggestions
				));
				setFilteredContacts(filteredContacts);
			} else {
				setFilteredContacts([]);
			}
		}, 300));
	}, [fieldValue, fieldName, crmContacts]);

	const getContactLabel = (contact: Api.CrmContact) => {
		const firstname = contact.firstName || '';
		const separator1 = firstname ? ' ' : '';
		const lastname = contact.lastName || '';
		const separator2 = firstname || lastname ? ' - ' : '';
		const email = contact.email || '';
		const separator3 = email ? ' ' : '';
		const company = contact.company || '';
		return `${firstname}${separator1}${lastname}${separator2}${email}${separator3}${company}`;
	};

	const renderContacts = (contacts: Api.CrmContact[]) => {
		const menuConfig: MenuConfig = {};
		contacts.forEach((contact, index) => {
			menuConfig[String(index)] = {
				label: getContactLabel(contact),
				onClick: () => dispatch(setFormFieldsByContact(contact)),
				hasSeparator: true,
			};
		});

		return (
			<Menu
				config={menuConfig}
				isDisplayed={isOpen}
			/>
		);
	};

	return renderContacts(filteredContacts);
};

export default CrmAutocompleteChoices;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/CrmAutocompleteChoices/index.tsx